import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ProductDetailComponent } from '../../../views/product-detail/product-detail.component';
import { MenuComponent } from '../../../views/menu/menu.component';
import { UserDataComponent } from '../../../views/user-data/user-data.component';
import { CartComponent } from '../../../views/cart/cart.component';
import { PedidosComponent } from '../../../views/pedidos/pedidos.component';
import { ConsumptionComponent } from '../../../views/consumption/consumption.component';
import { OrderConfirmationComponent } from '../../../views/order-confirmation/order-confirmation.component';
import { OrderDetailsComponent } from '../../../views/order-details/order-details.component';
import { IdentificationGuard } from '../../../guard/identification/identification.guard';
import { AuthenticationComponent } from '../../components/authentication/authentication.component';
import { verificationGuard } from '../../../guard/verification/verification.guard';
import { verificationCacheGuard } from '../../../guard/verification-cache/verification-cache.guard';
import { redirectGuard } from '../../../guard/redirect/redirect.guard';
import { AddressComponent } from '../../../views/address/address.component';
import { EditProductComponent } from '../../../views/edit-product/edit-product.component';
import { LoadingProcessingOrderComponent } from '../../components/loading-processing-order/loading-processing-order/loading-processing-order.component';
import { OrderConfirmationCounterComponent } from '../../../views/orderConfirmationCounter/order-confirmation-counter.component';
import { UserViewComponent } from '../../../views/user-view/user-view.component';
import { FidelityComponent } from '../../../views/fidelity/fidelity.component';
import { CouponsComponent } from '../../../views/coupons/coupons.component';
import { LayoutComponent } from 'src/app/shared/layout/layout.component';
import { ConnectionGuard } from 'src/app/guard/connection/connection.guard';
import { HistoryCashbackComponent } from 'src/app/views/history-cashback/history-cashback.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'landing/home',
    pathMatch: 'full'
  },
  {
    path: 'Authentication',
    component: AuthenticationComponent
  },
  {
    path: ':nameCompany',
    component: LayoutComponent,
    data: { animation: 'MenuPage' },
    children: [
      {
        path: '',
        component: MenuComponent,
        canActivate: [IdentificationGuard],
        data: { animation: 'MenuPage' },
        
      },
      {
        path: 'QrCode/:identification',
        component: MenuComponent,
        canActivate: [verificationGuard],
        data: { animation: 'MenuPage' },
      },
      {
        path: 'Counter/:identification',
        component: MenuComponent,
        canActivate: [verificationGuard],
        data: { animation: 'MenuPage' },
      },
      {
        path: 'B',
        component: MenuComponent,
        canActivate: [verificationCacheGuard],
        data: { animation: 'MenuPage' },
      },
      {
        path: 'P',
        component: MenuComponent,
        canActivate: [verificationCacheGuard],
        data: { animation: 'MenuPage' },
      },
      {
        path: 'product-detail/:id_product',
        component: ProductDetailComponent,
        canActivate: [ConnectionGuard],
        data: { animation: 'ProductDetailPage' },
      },
      {
        path: 'edit-product/:id_product',
        component: EditProductComponent,
        canActivate: [redirectGuard],
        data: { animation: 'EditProductPage' },
      },
      {
        path: 'order-details/:id_order',
        component: OrderDetailsComponent,
        canActivate: [ConnectionGuard],
        data: { animation: 'OrderDetailPage' },
      },
      {
        path: 'carrinho',
        component: CartComponent,
        canActivate: [redirectGuard],
        data: { animation: 'CartPage' },
      },
      {
        path: 'consumption',
        component: ConsumptionComponent,
        canActivate: [redirectGuard],
        data: { animation: 'ConsumptionPage' },
      },
      {
        path: 'user',
        component: UserViewComponent,
        canActivate: [redirectGuard],
        data: { animation: 'UserPage' },
      },
      {
        path: 'history-cashback',
        component: HistoryCashbackComponent,
        canActivate: [redirectGuard],
        data: { animation: 'HistoryCashbackPage' },
      },
      {
        path: 'fidelity',
        component: FidelityComponent,
        canActivate: [redirectGuard],
        data: { animation: 'FidelityPage' },
      },
      {
        path: 'coupons',
        component: CouponsComponent,
        canActivate: [redirectGuard],
        data: { animation: 'CouponsPage' },
      },
      {
        path: 'user-data',
        component: UserDataComponent,
        canActivate: [redirectGuard],
        data: { animation: 'UserDataPage' },
      },
      {
        path: 'address',
        component: AddressComponent,
        canActivate: [redirectGuard],
        data: { animation: 'AddressPage' },
      },
      {
        path: 'pedidos',
        component: PedidosComponent,
        canActivate: [ConnectionGuard],
        data: { animation: 'OrderPage' },
      },
      {
        path: 'order-confirmation',
        component: OrderConfirmationComponent,
        canActivate: [redirectGuard],
        data: { animation: 'OrderConfirmationPage' },
      },
      {
        path: 'order-confirmation-counter',
        component: OrderConfirmationCounterComponent,
        canActivate: [redirectGuard],
        data: { animation: 'OrderCounterPage' },
      },
      {
        path: 'processing/:type',
        component: LoadingProcessingOrderComponent,
        canActivate: [redirectGuard],
        // data: { animation: 'ProcessingPage' },
      }
    ],
  },
  {
    path: 'landing',
    loadChildren: () => import('../../../landing-page/landing.module').then(m => m.LandingModule)
  },
  {
    path: '**',
    redirectTo: 'landing/home',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes,{
    // scrollPositionRestoration: 'top',
    // anchorScrolling: 'enabled',
    
  })],
  exports: [RouterModule],
  providers:[IdentificationGuard, verificationGuard, verificationCacheGuard, redirectGuard, ConnectionGuard]
})

export class AppRoutingModule{}
